/**
 * Буквы для аватара: первые буквы двух первых слов имени, у почты первая
 * буква адреса. Пустое имя даёт пустую строку, аватар тогда с иконкой.
 */
export function initials(name: string | null | undefined): string {
  const value = (name ?? "").trim();
  if (!value) return "";
  if (value.includes("@") && !value.includes(" ")) {
    return value.charAt(0).toUpperCase();
  }
  return value
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => Array.from(word)[0] ?? "")
    .join("")
    .toUpperCase();
}

// Байты Intl пишет словом («512 byte»), поэтому самая мелкая единица КБ.
const UNITS = ["kilobyte", "megabyte", "gigabyte"] as const;

/**
 * Размер вложения единицами языка интерфейса (Intl: «1,5 МБ», «1.5 MB»),
 * без своих ключей перевода. Отрицательный или нечисловой размер не
 * показывается.
 */
export function formatFileSize(bytes: number, locale: string): string | null {
  if (!Number.isFinite(bytes) || bytes < 0) return null;
  if (bytes < 1024) {
    try {
      return new Intl.NumberFormat(locale || "en", {
        style: "unit",
        unit: "byte",
        unitDisplay: "short",
      }).format(bytes);
    } catch {
      return `${bytes} B`;
    }
  }
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  try {
    return new Intl.NumberFormat(locale || "en", {
      style: "unit",
      unit: UNITS[unit],
      unitDisplay: "short",
      maximumFractionDigits: 1,
    }).format(value);
  } catch {
    return `${Math.round(value * 10) / 10} ${["KB", "MB", "GB"][unit]}`;
  }
}
